import { render } from "./CorporateBranding.vue?vue&type=template&id=93cdb0aa&scoped=true"
import script from "./CorporateBranding.vue?vue&type=script&lang=js"
export * from "./CorporateBranding.vue?vue&type=script&lang=js"

import "./corporate-branding.scss?vue&type=style&index=0&id=93cdb0aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93cdb0aa"]])

export default __exports__